import { render, staticRenderFns } from "./TableInspect.vue?vue&type=template&id=8893280c&scoped=true"
import script from "./TableInspect.vue?vue&type=script&lang=js"
export * from "./TableInspect.vue?vue&type=script&lang=js"
import style0 from "./TableInspect.vue?vue&type=style&index=0&id=8893280c&prod&scoped=true&lang=scss"
import style1 from "./TableInspect.vue?vue&type=style&index=1&id=8893280c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8893280c",
  null
  
)

export default component.exports